import {useMemo} from "react";
import {useSelector} from "react-redux";
import {useSearchParams} from "react-router-dom";
import {useGetCampaignParametersQuery} from "../../../core/reducers/parameters";
import {useGetAllCampaignTypesQuery} from "../../../core/reducers/campaignType";
import {getEnvName} from "../../Utils/CommonUtils";
import AudienceEditor from "../../Audience/AudienceEditor";
import {AUDIENCE_VARIANTS} from "../../Audience/audienceEditorModel";

// карта правило -> оператор живёт в модели формы; экспорт сохранён для AB-тестов
export {POSSIBLE_OPERATORS} from "../campaignFormModel";

/** Сокращения типов кампаний (LavaQuest -> LQ) для подписей значений type_inactive. */
export const useTypeAbbreviations = () => {
    const {data: types} = useGetAllCampaignTypesQuery();
    return useMemo(() => Object.fromEntries(
        Object.entries(types || {})
            .filter(([, type]) => type.metaData?.abbreviation)
            .map(([key, type]) => [key, type.metaData.abbreviation])
    ), [types]);
};

/**
 * Шаг "audience" конструктора кампаний / шаблонов, также используется в AudienceBulkUpdateDialog.
 * API пропсов прежний: currentCampaign, setCurrentCampaign, errorAudienceIndexes, errorFields, isTemplate и handle*.
 */
export default function AudienceStep(props) {
    const sourceMode = useSelector((state) => state.data.SourceMode);
    const [searchParams] = useSearchParams();
    const env = getEnvName('env', sourceMode, searchParams);
    const paramsQuery = useGetCampaignParametersQuery({env});
    const abbreviations = useTypeAbbreviations();

    return (
        <AudienceEditor
            item={props.currentCampaign}
            setItem={props.setCurrentCampaign}
            handlers={props}
            params={paramsQuery.data}
            paramsQuery={paramsQuery}
            variant={AUDIENCE_VARIANTS.campaign}
            abbreviations={abbreviations}
            errorAudienceIndexes={props.errorAudienceIndexes}
            errorFields={props.errorFields}
            showRepeatable={!props.isTemplate}
        />
    );
}
